import { Collapse, Divider, Drawer, Grid, IconButton, List, ListItem, ListItemText, Toolbar, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { PropertySetup } from "./UserConfiguration/PropertySetup";
import { ChangePassword } from "./UserConfiguration/ChangePassword";
import { UserRoleConfig } from "./UserConfiguration/UserRoleConfig";

interface SidebarProps {
  onMenuClick: (menu: string) => void;
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}
export const BackendSideBar:React.FC<SidebarProps>
   =React.memo(({onMenuClick , sidebarOpen, toggleSidebar})=>{
    
  const [configOpen, setConfigOpen] = useState(true);
  const [toolsOpen, setToolsOpen] = useState(true);
  const [maintananceOpen, setMaintananceOpen] = useState(true);
  const [giftcardOpen, setGiftCardOpen] = useState(true);
  const [payrollOpen, setPayrollOpen] = useState(true);
  const [banquetOpen, setBanquetOpen] = useState(true);
  const [outletOpen, setOutletOpen] = useState(true);
  const [userConfigOpen, setUserConfigOpen] = useState(false);
  const [costCenterOpen, setCostCenterOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [appearanceOpen, setAppearanceOpen] = useState(false);
  const [expensemanagementOpen, setExpenseManagementOpen] = useState(false);
  const [utilityOpen, setUtilityOpen] = useState(false);
  const [printingTemplateOpen,setPrintingTemplateOpen] = useState(false);
  const [languageOpen,setLanguageOpen] = useState(false);
  const [otherOpen,setOtherOpen] = useState(false);
  const [propertySetupOpen,setPropertySetupOpen] = useState(false);
  const [changepasswordOpen,setChangepasswordOpen] = useState(false);
  const [userroleconfigOpen,setUserRoleConfigOpen] = useState(false);

 /**
   * Config open
   */
  const toggleConfigOpen = () => {
    setConfigOpen((prev) => !prev);
  };
  /**
   * Tools open
   */
  const toggleToolsOpen = () => {
    setToolsOpen((prev) => !prev);
  };
  /**
   * Maintenance open
   */
  const toggleMaintananceOpen = () => {
    setMaintananceOpen((prev) => !prev);
  };
  /**
   * Gift card open
   */
  const toggleGiftCardOpen = () => {
    setGiftCardOpen((prev) => !prev);
  };
  /**
   * Payroll open
   */
  const togglePayrollOpen = () => {
    setPayrollOpen((prev) => !prev);
  };
  /**
   * Banquet open
   */
  const toggleBanquetOpen = () => {
    setBanquetOpen((prev) => !prev);
  };
  /**
   * Outlet open
   */
  const toggleOutletOpen = () => {
    setOutletOpen((prev) => !prev);
  };
 /**
   * PropertySetup dialogue
   */
 const handlePropertySetupClick = () => {
  setPropertySetupOpen(true); 
};
const handlePropertySetupClose = () => {
  setPropertySetupOpen(false); 
};
/**
 * Change Password dialogue
 */
const handleChangePasswordClick = () => {
  setChangepasswordOpen(true); 
};
const handleChangePasswordClose = () => {
  setChangepasswordOpen(false); 
};
/**
 * User Role Config
 */
const handleUserConfigClick = () => {
  setUserRoleConfigOpen(true); 
};
const handleUserConfigClose = () => {
  setUserRoleConfigOpen(false); 
};
/**
 * 
 * @param submenu 
 */
 
  const handleOpenSubMenu = (submenu: string) => {
    // Ensure only the clicked submenu is open
    setUserConfigOpen(submenu === "userConfig");
    setCostCenterOpen(submenu === "costCenter");
    setPaymentOpen(submenu === "payment");
    setMasterOpen(submenu === "master")
    setAppearanceOpen(submenu === "appearence")
    setExpenseManagementOpen(submenu === "expensemanagement")
    setUtilityOpen(submenu === "utility")
    setPrintingTemplateOpen(submenu === "printingtemplate")
    setLanguageOpen(submenu === "language")
    setOtherOpen(submenu === "other")
  };

    return(
        <>
      <Drawer
      variant="permanent"
      open={sidebarOpen}
      sx={{
        width: sidebarOpen ? 230 : 72,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: sidebarOpen ? 230 : 72,
          boxSizing: 'border-box',
          backgroundColor: '#3a5569',
          color: '#fff',
        },
      }}
    >
      <Toolbar />
      <Grid >
        <List>
          <ListItem button onClick={toggleSidebar}>
            <IconButton color="inherit"><WSIcons.SearchIcon /></IconButton>
            {sidebarOpen && <ListItemText primary="Operation Search" />}
          </ListItem>
          <Divider />

          {/* Configuration Item with Nested List */}
          <ListItem button onClick={toggleConfigOpen}>
            <IconButton color="inherit"><WSIcons.SettingsIcon /></IconButton>
            {sidebarOpen && <ListItemText primary="Configuration" />}
            {sidebarOpen && (configOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={configOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}  onClick={() => handleOpenSubMenu("userConfig")}>
                <ListItemText primary="User Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}  onClick={() => handleOpenSubMenu("costCenter")}>
                <ListItemText primary="Cost Center" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleOpenSubMenu("payment")}>
                <ListItemText primary="Payment & Accounts" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}  onClick={() => handleOpenSubMenu("master")}>
                <ListItemText primary="Masters" />
              </ListItem>
            </List>
          </Collapse>
          <Divider />
          <ListItem button onClick={toggleToolsOpen}>
            <IconButton color="inherit"><WSIcons.ToolsIcon /></IconButton>
            {sidebarOpen && <ListItemText primary="Tools" />}
            {sidebarOpen && (toolsOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={toolsOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleOpenSubMenu("appearence")}>
                <ListItemText primary="Appearance" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleOpenSubMenu("expensemanagement")}>
                <ListItemText primary="Expense Management" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleOpenSubMenu("utility")}>
                <ListItemText primary="Utility" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => handleOpenSubMenu("printingtemplate")}>
                <ListItemText primary="Printing Template" />
              </ListItem>
            </List>
          </Collapse>
          <Divider />
          <ListItem button onClick={toggleMaintananceOpen}>
            <IconButton color="inherit"><WSIcons.MaintananceIcon /></IconButton>
            {sidebarOpen && <ListItemText primary="Maintenance" />}
            {sidebarOpen && (maintananceOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={maintananceOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Language" onClick={()=> handleOpenSubMenu("language")}/>
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Other" onClick={()=> handleOpenSubMenu("other")}/>
              </ListItem>
            </List>
          </Collapse>

          <Divider />
          <ListItem button onClick={toggleGiftCardOpen}>
            <IconButton color="inherit"><WSIcons.CardGiftcardIcon/></IconButton>
            {sidebarOpen && <ListItemText primary="Gift Card Management" />}
            {sidebarOpen && (giftcardOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={giftcardOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Transaction" />
              </ListItem>
            </List>
          </Collapse>

          <Divider />
          <ListItem button onClick={togglePayrollOpen}>
            <IconButton color="inherit"><WSIcons.PaymentsIcon/></IconButton>
            {sidebarOpen && <ListItemText primary="Payroll Management" />}
            {sidebarOpen && (payrollOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={payrollOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Transaction" />
              </ListItem>
            </List>
          </Collapse>

          <Divider />
          <ListItem button onClick={toggleBanquetOpen}>
            <IconButton color="inherit"><WSIcons.RoomServiceIcon/></IconButton>
            {sidebarOpen && <ListItemText primary="Banquet Setup" />}
            {sidebarOpen && (banquetOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={banquetOpen && sidebarOpen } timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Transaction" />
              </ListItem>
            </List>
          </Collapse>
          <Divider />
          <ListItem button onClick={toggleOutletOpen}>
            <IconButton color="inherit"><WSIcons.OutletIcon/></IconButton>
            {sidebarOpen && <ListItemText primary="Outlet" />}
            {sidebarOpen && (outletOpen ? <WSIcons.ExpandLessIcon /> : <WSIcons.ExpandMoreIcon />)}
          </ListItem>
          <Collapse in={outletOpen && sidebarOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Masters" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Menu Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Item Configuration" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }}>
                <ListItemText primary="Transaction" />
              </ListItem>
            </List>
          </Collapse>
        </List>
      </Grid>
    </Drawer>
    <Grid
     
      sx={{
        flexShrink: 0,
        backgroundColor: '#3a5569',
        width: sidebarOpen ? 200 : 0,
        color: '#fff',
        overflow: 'auto', // Enables scrolling
      }}
      
    >
      <Toolbar />
      <Grid >
        {/* Render the User Configuration submenu */}
        {userConfigOpen && (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>User Configuration</Typography>
            <ListItem button>
              <ListItemText primary="Property Setup" onClick={handlePropertySetupClick}/>
            </ListItem>
            <PropertySetup open={propertySetupOpen} onClose={handlePropertySetupClose}/>
            <ListItem button>
              <ListItemText primary="User Operation" onClick={() => onMenuClick('useroperation')}/>
            </ListItem>
            <ListItem button>
              <ListItemText primary="Change Password" onClick={handleChangePasswordClick}/>
            </ListItem>
            <ChangePassword open={changepasswordOpen} onClose={handleChangePasswordClose}/>
            <ListItem button>
              <ListItemText primary="User Role" onClick={() => onMenuClick('userrole')}/>
            </ListItem>
            <ListItem button>
              <ListItemText primary="User Role Configuration" onClick={handleUserConfigClick}/>
            </ListItem>
            <UserRoleConfig open={userroleconfigOpen} onClose={handleUserConfigClose}/>

          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {costCenterOpen && (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Cost Center</Typography>
            <ListItem button>
              <ListItemText primary="Store Operation" onClick={() => onMenuClick('store')}/>
            </ListItem>
            <ListItem button>
              <ListItemText primary="Outlet Operation" onClick={() => onMenuClick('outlet')}/>
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {paymentOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Payment & Accounts</Typography>
            <ListItem button>
              <ListItemText primary="Settlement Type" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Exchange Rate" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Extra Charge Category" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Extra Charge" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Account Type" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Account" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Vendor" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="No Charge Account" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="No Charge Group" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {masterOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Masters</Typography>
            <ListItem button>
              <ListItemText primary="Unit" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Guest Database" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Void Reason" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Credit Terms" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="E-Mail Accounts" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Market Place" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Business Source" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Preparation Remark" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Pantry Message" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Table Notification" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Course (meal)" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Session (meal)" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Credit Card Prefix" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Address Lookup" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {appearanceOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Appearance</Typography>
            <ListItem button>
              <ListItemText primary="Cash Drawer" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Table Images" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Item Images" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Printer Mapping" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Kitchen Monitor" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {expensemanagementOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Expense Management</Typography>
            <ListItem button>
              <ListItemText primary="Payable Transaction" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Receivable Transaction" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {utilityOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Utility</Typography>
            <ListItem button>
              <ListItemText primary="Reminder" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Phone Directory" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Message Box" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Mail" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Cash In" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Cash Out" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Net-Locks" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {printingTemplateOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Printing Template</Typography>
            <ListItem button>
              <ListItemText primary="Windows Printer" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Line Printer" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Letter Template" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {languageOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Language</Typography>
            <ListItem button>
              <ListItemText primary="Change Message" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Other Language" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Export Language" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Import Language" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Keyboard Configuration" />
            </ListItem>
          </List>
        )}
      </Grid>
      <Grid >
        {/* Render the User Configuration submenu */}
        {otherOpen&& (
          <List>
            <Typography align='center' variant='h6' sx={{backgroundColor:"navy"}}>Other</Typography>
            <ListItem button>
              <ListItemText primary="Report Settings" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Open/Close Shift" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Clean Up" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Auto Backup Schedule Task" />
            </ListItem>
          </List>
        )}
      </Grid>
    </Grid>
    </>
    )
})